import { PROMPT_NAMES } from 'woop-shared/prompts/names';

export const DUPLICATED_DRIVER_FIELDS = new Set([
  PROMPT_NAMES.EMAIL,
  PROMPT_NAMES.FIRST_NAME,
  PROMPT_NAMES.LAST_NAME,
  PROMPT_NAMES.DOB
]);
